// extracted by mini-css-extract-plugin
export default {"loadingScreen":"LoadingScreen_loadingScreen__bZjB6","fadeIn":"LoadingScreen_fadeIn__GKLHX"};